import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { kannapolisConfig } from "./data";

export default function KannapolisPage() {
  return <CityPageTemplate config={kannapolisConfig} />;
}